import React, {useEffect, useState} from 'react';
import commaSeparator, {formatToPersianAddComma} from "../../../utils/CommaSeparator";
import utilsFunction from "../../../utils/utilsFunction";
import numeric from "../../../utils/NumericFunction";
import {useDispatch, useSelector} from "react-redux";
import {CalculateInformationUnderTable, drawNew} from "./functions";
import {submitDocumentFormAction} from "../../Store/SubmitDocumentForm";

const MyCustomChartBalance = () => {
  const sendData = useSelector(s => s.submitDocumentFormReducer)


  return (
    <div
      className={"d-flex justify-content-end position-relative mx-5 look__after"}
      style={{
        width: `${sendData.chartDataUnderTable.totalWidth}px`,
        height: '50px',
        borderRadius: 10,
        color: "whitesmoke",
        overflow: "hidden"
        //
      }}
    >
      {sendData.chartDataUnderTable.isShow ? <>
        <div
          className={"d-flex justify-content-start align-items-center"}
          style={{
            zIndex: Math.floor(sendData.chartDataUnderTable.besWidth),
            width: sendData.chartDataUnderTable.bedWidth + "%",
            backgroundColor: '#85ffbd',
            backgroundImage: 'radial-gradient( circle 860px at 11.8% 33.5%,  rgba(240,30,92,1) 0%, rgba(244,49,74,1) 30.5%, rgba(249,75,37,1) 56.1%, rgba(250,88,19,1) 75.6%, rgba(253,102,2,1) 100.2% )',
          }}>
          {sendData.chartDataUnderTable.bedWidth > 1 && <span className={"mx-2"}>بدهکار</span>}
        </div>
        <div
          className={"d-flex justify-content-end align-items-center"}
          style={{
            zIndex: Math.floor(sendData.chartDataUnderTable.bedWidth),
            width: sendData.chartDataUnderTable.besWidth + "%",
            backgroundImage: 'radial-gradient(circle at -1% 57.5%, rgb(19, 170, 82) 0%, rgb(0, 102, 43) 90%)',
          }}>
          {sendData.chartDataUnderTable.besWidth > 1 && <span className={"mx-2"}>بستانکار</span>}
        </div>
        <div className={"position-absolute"}
             style={{
               zIndex: `max(${Math.floor(sendData.chartDataUnderTable.bedWidth)},${Math.floor(sendData.chartDataUnderTable.besWidth)})`, // set 3 zIndex in this page to
               top: '50%', left: '50%', transform: ' translate(-50%, -50%)', // bottom: 0
             }}
        >
          {sendData.remainToBalance === 0 ?
            <>
            <span style={{
              borderRadius: 5, border: '1px solid', padding: 6, background: "green",
            }}>=</span></>
            :
            <>
              <span style={{
                borderRadius: 5, border: '1px solid', padding: 6, background: "red",
              }}>
               {formatToPersianAddComma(sendData.remainToBalance)}
              </span>
            </>
          }
        </div>
        <div className={"position-absolute"}
             style={{
               zIndex: `max(${Math.floor(sendData.chartDataUnderTable.bedWidth)},${Math.floor(sendData.chartDataUnderTable.besWidth)})`, // set 3 zIndex in this page to
               bottom: '0', left: '50%', transform: ' translate(-50%, 10%)', // bottom: 0
             }}
        >
          &#8595;
        </div>
      </> : <></>}

    </div>
  );
};

export default MyCustomChartBalance;
